import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setExperienceLevel } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const ExperienceLevelDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Experience"
      id="experience_level_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setExperienceLevel(option.id))
      }}
    />
  )
}
export default ExperienceLevelDropdown
